import type { ReactElement } from "react";

export enum EModalTypeOpen {
    INVITE_USERS_MODAL_OPEN = "inviteUsersModalOpen",
    INVITATION_TYPE_MODAL_OPEN = "invitationTypeModalOpen",
}

export interface IModalsState {
    [EModalTypeOpen.INVITE_USERS_MODAL_OPEN]: boolean;
    [EModalTypeOpen.INVITATION_TYPE_MODAL_OPEN]: boolean;
}

export interface IUserInvitation {
    invitationButtonComponent: ReactElement;
    invitationBannerComponent: ReactElement;
    invitationModalComponent: ReactElement;
    isProminent: boolean;
    handleOpenModal: () => void;
}

export interface IEmailAddress {
    value: string;
    isValid: boolean;
}

export interface IInviteUsersTranslations {
    button: {
        tooltipContent: string;
    };
    banner: {
        title: string;
        subtitle: string;
        buttonText: string;
    };
    modal: {
        title: string;
        description: string;
        placeholder: string;
        errorMessage: string;
        sendButtonText: string;
    };
}
